import React, { useState } from "react";
import { DateRangePicker } from "rsuite";
import Calendar from "../assets/Calendar.png";
import { useTranslation } from "react-i18next";

const MultiDatePicker = () => {
  const [value, setValue] = useState([null, null]); // default empty
  const { t, i18n } = useTranslation();

  // detect locale for date formatting
  const locale = i18n.language === "ar" ? "ar-EG" : "en-US";

  return (
    <div className="calendar-box btn-border-box d-flex align-items-center gap-1 position-relative">
      {/* Hidden Input for form submission */}
      <input
        type="hidden"
        name="daterange"
        value={
          value[0] && value[1]
            ? `${value[0]?.toLocaleDateString(locale)} - ${value[1]?.toLocaleDateString(locale)}`
            : ""
        }
      />

      {/* Left Icon */}
      <div className="left-icons">
        <img src={Calendar} alt="calendar" />
      </div>

      {/* Right Calendar Details */}
      <div className="right-calendar-details">
        <p>{t("bookingDate")}</p>
        <h5>
          {value[0] && value[1] ? (
            <>
              {value[0].toLocaleDateString(locale, {
                weekday: "short",
                day: "numeric",
                month: "short",
              })}{" "}
              --{" "}
              {value[1].toLocaleDateString(locale, {
                weekday: "short",
                day: "numeric",
                month: "short",
              })}
            </>
          ) : (
            t("checkInOut")
          )}
        </h5>
      </div>

      {/* RSuite Picker (overlay but invisible) */}
      <DateRangePicker
        value={value}
        onChange={setValue}
        placeholder={t("selectDate")}
        appearance="subtle"
        className="position-absolute w-100 h-100 top-0 start-0 opacity-0"
        placement="bottomStart"
        format="dd/MM/yyyy"
        character=" - "
      />
    </div>
  );
};

export default MultiDatePicker;
